import { HexType, guardNever } from "@hex/common";
import React from "react";

import {
  ComponentIcon,
  ExploreIcon,
  EyeClosedIcon,
  ProjectIcon,
  PublishedProjectIcon,
  ThreadIcon,
} from "../../icons/CustomIcons.js";

export interface ProjectCardTypeIconProps {
  hexType: HexType;
  isPublished?: boolean;
  isUnknownHex?: boolean;
  className?: string;
}

export const ProjectCardTypeIcon = React.memo<ProjectCardTypeIconProps>(
  function ProjectCardTypeIcon({
    className,
    hexType,
    isPublished,
    isUnknownHex = false,
  }) {
    if (isUnknownHex) {
      return <EyeClosedIcon className={className} />;
    }
    if (hexType === HexType.COMPONENT) {
      return <ComponentIcon className={className} />;
    } else if (hexType === HexType.PROJECT) {
      if (isPublished) {
        return <PublishedProjectIcon className={className} />;
      } else {
        return <ProjectIcon className={className} />;
      }
    } else if (hexType === HexType.EXPLORE) {
      return <ExploreIcon className={className} />;
    } else if (hexType === HexType.ASK) {
      return <ThreadIcon className={className} />;
    } else {
      guardNever(hexType, hexType);
    }

    return <ProjectIcon className={className} />;
  },
);
